export default __webpack_public_path__ + "static/media/paperplane_regular.4a921c5d.gif";